import { Search } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import { Input } from '@/components/ui/input'

export function SearchInput() {
  const [searchParams, setSearchParams] = useSearchParams()
  const searchValue = searchParams.get('search') || ''
  const [inputValue, setInputValue] = useState(searchValue)
  const { t } = useTranslation('layout')

  useEffect(() => {
    if (inputValue === searchValue) return

    const timer = setTimeout(() => {
      const next = new URLSearchParams(searchParams)
      if (inputValue) next.set('search', inputValue)
      else next.delete('search')
      // A new search re-shuffles the whole result set, so the old page number
      // is meaningless - keep the offset and page 3 of the previous list hides
      // the first N matches. Filter panels drop the offset for the same reason.
      next.delete('offset')
      setSearchParams(next)
    }, 600)

    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue])

  return (
    <div className="relative w-full sm:max-w-xs">
      <Search className="pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        type="search"
        placeholder={t('common.search')}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        className="pl-10"
      />
    </div>
  )
}
